//import CIcon from '@coreui/icons-react';
import { useContext } from "react";
//import { FaSitemap, FaHome, FaUsers, FaUserPlus } from 'react-icons/fa'
// import { GiSpellBook } from 'react-icons/gi'
// import { GoReport } from 'react-icons/go'
import { Authcontext } from "../views/components/Context/Context";
//import HomeIcon from '@material-ui/icons/Home';
const Navigation = () => {
  const { state, dispatch } = useContext(Authcontext);
  // console.log(state,"state");

  return state.userType === "Teaching"
    ? [
        {
          _tag: "CSidebarNavItem",
          name: "Katbook (Teacher Login)",
          to: `/TeacherView/${state.url}`,
        },
      ]
    : state?.isThirdParty
    ? [
        // {
        //   _tag: "CSidebarNavItem",
        //   name: "UEducate 3D Model",
        //   route: "/base",
        //   icon: "cil-task",
        //   to: "/UeducateModel",
        //   onClick: () => {
        //     if (state) {
        //       if (state.route === "Ueducate / 3D Model") {
        //         return 0;
        //       } else {
        //         dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //       }
        //     } else {
        //       dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //     }
        //   },
        //   txt: state.route === "Katbook Initiation" ? state.route : null,

        //   // _children: [],
        // },
        {
          _tag: "CSidebarNavItem",
          name: "Staff Subject Allocation",
          route: "/base",
          icon: "cil-task",
          to: "/StaffIndex",
          onClick: () => {
            if (state) {
              if (state.route === "Staff Subject Allocation") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook Initiation" ? state.route : null,

          // _children: [],
        },
        {
          _tag: "CSidebarNavItem",
          name: "Planning and Scheduling",
          route: "/PlanningScheduleTile",
          to: "/PlanningScheduleTile",
          icon: "cil-pencil",
          // _children: [],
          onClick: () => {
            if (state) {
              if (state.route === "PlanningScheduleTile") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "PlanningScheduleTile" ? state.route : null,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Diary",
          route: "/base",
          icon: "cil-file",
          to: "/Diary",
          // _children: [],
          onClick: () => {
            if (state) {
              if (state.route === "Diary") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
        },
      ]
    : state?.userType === "Content Developer"
    ? [
        // {
        //   _tag: "CSidebarNavItem",
        //   name: "Dashboard",
        //   to: "/",
        //   icon: "cil-home",
        // },
        // {
        //   _tag: "CSidebarNavItem",
        //   name: "UEducate 3D Model",
        //   route: "/base",
        //   icon: "cil-task",
        //   to: "/UeducateModel",
        //   onClick: () => {
        //     if (state) {
        //       if (state.route === "Ueducate / 3D Model") {
        //         return 0;
        //       } else {
        //         dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //       }
        //     } else {
        //       dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //     }
        //   },
        //   txt: state.route === "Katbook Initiation" ? state.route : null,

        //   // _children: [],
        // },
        {
          _tag: "CSidebarNavItem",
          name: "Staff Subject Allocation",
          route: "/base",
          icon: "cil-task",
          to: "/StaffIndex",
          onClick: () => {
            if (state) {
              if (state.route === "Staff Subject Allocation") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook Initiation" ? state.route : null,

          // _children: [],
        },
        {
          _tag: "CSidebarNavItem",
          name: "Planning and Scheduling",
          route: "/PlanningScheduleTile",
          to: "/PlanningScheduleTile",
          icon: "cil-pencil",
          // _children: [],
          onClick: () => {
            if (state) {
              if (state.route === "PlanningScheduleTile") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "PlanningScheduleTile" ? state.route : null,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Diary",
          route: "/base",
          icon: "cil-file",
          to: "/Diary",
          // _children: [],
          onClick: () => {
            if (state) {
              if (state.route === "Diary") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
        },
      ]
    : !state.UserTypecode
    ? [
        {
          _tag: "CSidebarNavItem",
          name: "Dashboard",
          to: "/dashboard",
          icon: "cil-home",
        },
        {
          _tag: "CSidebarNavItem",
          name: "Administrator",
          route: "/Administrator",
          to: "/AdministratorTile",
          icon: "cil-user",
          onClick: () => {
            if (state) {
              if (state.route === "Administrator") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Administrator" ? state.route : null,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Human Resource",
          route: "/HumanResourceTile",
          to: "/HumanResourceTile",
          icon: "cil-people",
        },
        {
          _tag: "CSidebarNavItem",
          name: "Katbook Initiation",
          to: "/katbookInitiation",
          icon: "cil-bookmark",
          onClick: () => {
            if (state) {
              if (state.route === "Katbook Initiation") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook Initiation" ? state.route : null,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Activities Master",
          route: "/ContentPreparationTile",
          to: "/ContentPreparationTile",
          icon: "cil-file",
          onClick: () => {
            if (state) {
              if (state.route === "Content Preparation Tile") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Content Preparation Tile" ? state.route : null,
          //icon: <FaUsers className="c-sidebar-nav-icon" />,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Staff Subject Allocation",
          route: "/base",
          icon: "cil-task",
          to: "/StaffIndex",
          onClick: () => {
            if (state) {
              if (state.route === "Staff Subject Allocation") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook Initiation" ? state.route : null,

          // _children: [],
        },
        {
          _tag: "CSidebarNavItem",
          name: "Planning and Scheduling",
          route: "/PlanningScheduleTile",
          to: "/PlanningScheduleTile",
          icon: "cil-pencil",
          // _children: [],
          onClick: () => {
            if (state) {
              if (state.route === "PlanningScheduleTile") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "PlanningScheduleTile" ? state.route : null,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Diary",
          route: "/base",
          icon: "cil-file",
          to: "/Diary",
          // _children: [],
          onClick: () => {
            if (state) {
              if (state.route === "Diary") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
        },
        {
          _tag: "CSidebarNavItem",
          name: "Draft Katbook Content",
          route: "/Draft",
          to: "/Draft",
          icon: "cil-task",
          // _children: [],
        },
        {
          _tag: "CSidebarNavItem",
          name: "Katbook Creation",
          route: "/KatbookCreation",
          to: "/KatbookCreation",
          icon: "cil-pencil",
          onClick: () => {
            if (state) {
              if (state.route === "Katbook Creation") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook Creation" ? state.route : null,
          //icon: <FaUsers className="c-sidebar-nav-icon" />,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Self Assessment",
          route: "/SelfAssessment",
          to: "/SelfAssessment",
          icon: "cil-pencil",
          onClick: () => {
            if (state) {
              if (state.route === "Self Assessment") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Self Assessment" ? state.route : null,
          //icon: <FaUsers className="c-sidebar-nav-icon" />,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Katbook (Published)",
          to: "/KatBookView",
          icon: "cil-book",
          //       style:{
          // display:State.userCreds.userType === 'Teaching'? 'none':'',
          //       },
          onClick: () => {
            if (state) {
              if (state.route === "Katbook (Published)") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook (Published)" ? state.route : null,
        },
        {
          _tag: "CSidebarNavItem",
          name: "UEducate 3D Model",
          route: "/base",
          icon: "cil-task",
          to: "/UeducateModel",
          onClick: () => {
            if (state) {
              if (state.route === "Ueducate / 3D Model") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook Initiation" ? state.route : null,

          // _children: [],
        },
        {
          _tag: "CSidebarNavItem",
          name: "Embibe Subject Mapping",
          to: "/BookMapping",
          icon: "cil-book",
          //       style:{
          // display:State.userCreds.userType === 'Teaching'? 'none':'',
          //       },
          onClick: () => {
            if (state) {
              if (state.route === "Embibe Subject Mapping") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Embibe Subject Mapping" ? state.route : null,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Proceum Content",
          to: "/ProceumContent",
          icon: "cil-book",
          //       style:{
          // display:State.userCreds.userType === 'Teaching'? 'none':'',
          //       },
          onClick: () => {
            if (state) {
              if (state.route === "Proceum Content") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Proceum Content" ? state.route : null,
        },
      ]
    : [
        {
          _tag: "CSidebarNavItem",
          name: "Dashboard",
          to: "/dashboard",
          icon: "cil-home",
        },
        {
          _tag: "CSidebarNavItem",
          name: "Administrator",
          route: "/Administrator",
          to: "/AdministratorTile",
          icon: "cil-user",
          onClick: () => {
            if (state) {
              if (state.route === "Administrator") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Administrator" ? state.route : null,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Human Resource",
          route: "/HumanResourceTile",
          to: "/HumanResourceTile",
          icon: "cil-people",
        },
        {
          _tag: "CSidebarNavItem",
          name: "Katbook Initiation",
          to: "/katbookInitiation",
          icon: "cil-bookmark",
          onClick: () => {
            if (state) {
              if (state.route === "Katbook Initiation") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook Initiation" ? state.route : null,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Activities Master",
          route: "/ContentPreparationTile",
          to: "/ContentPreparationTile",
          icon: "cil-file",
          onClick: () => {
            if (state) {
              if (state.route === "Content Preparation Tile") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Content Preparation Tile" ? state.route : null,
          //icon: <FaUsers className="c-sidebar-nav-icon" />,
        },

        {
          _tag: "CSidebarNavItem",
          name: "Staff Subject Allocation",
          route: "/base",
          icon: "cil-task",
          to: "/StaffIndex",
          onClick: () => {
            if (state) {
              if (state.route === "Staff Subject Allocation") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook Initiation" ? state.route : null,

          // _children: [],
        },
        {
          _tag: "CSidebarNavItem",
          name: "Planning and Scheduling",
          route: "/PlanningScheduleTile",
          to: "/PlanningScheduleTile",
          icon: "cil-pencil",
          // _children: [],
          onClick: () => {
            if (state) {
              if (state.route === "PlanningScheduleTile") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "PlanningScheduleTile" ? state.route : null,
        },
        {
          _tag: "CSidebarNavItem",
          name: "Diary",
          route: "/base",
          icon: "cil-file",
          to: "/Diary",
          // _children: [],
          onClick: () => {
            if (state) {
              if (state.route === "Diary") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
        },
        {
          _tag: "CSidebarNavItem",
          name: "Draft Katbook Approval",
          route: "/Approved/Draft",
          to: "/Approved/Draft",
          icon: "cil-file",
          // _children: [],
        },
        {
          _tag: "CSidebarNavItem",
          name: "Katbook Creation",
          route: "/KatbookCreation",
          to: "/KatbookCreation",
          icon: "cil-pencil",
          onClick: () => {
            if (state) {
              if (state.route === "Katbook Creation") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook Creation" ? state.route : null,
          //icon: <FaUsers className="c-sidebar-nav-icon" />,
        },
        // {
        //   _tag: "CSidebarNavItem",
        //   name: "Assets Library",
        //   route: "/AssetsLibrary",
        //   to: "/AssetsLibrary",
        //   icon: "cil-pencil",
        //   onClick: () => {
        //     if (state) {
        //       if (state.route === "Assets Library") {
        //         return 0;
        //       } else {
        //         dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //       }
        //     } else {
        //       dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //     }
        //   },
        //   txt: state.route === "Assets Library" ? state.route : null,
        //   //icon: <FaUsers className="c-sidebar-nav-icon" />,
        // },
        {
          _tag: "CSidebarNavItem",
          name: "Self Assessment",
          route: "/SelfAssessment",
          to: "/SelfAssessment",
          icon: "cil-pencil",
          onClick: () => {
            if (state) {
              if (state.route === "Self Assessment") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Self Assessment" ? state.route : null,
          //icon: <FaUsers className="c-sidebar-nav-icon" />,
        },
        // {
        //   _tag: "CSidebarNavItem",
        //   name: "UEducate 3D Model",
        //   route: "/base",
        //   icon: "cil-task",
        //   to: "/UeducateModel",
        //   onClick: () => {
        //     if (state) {
        //       if (state.route === "Ueducate / 3D Model") {
        //         return 0;
        //       } else {
        //         dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //       }
        //     } else {
        //       dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //     }
        //   },
        //   txt: state.route === "Katbook Initiation" ? state.route : null,

        //   // _children: [],
        // },
        {
          _tag: "CSidebarNavItem",
          name: "Katbook (Published)",
          to: "/KatBookView",
          icon: "cil-book",
          //       style:{
          // display:State.userCreds.userType === 'Teaching'? 'none':'',
          //       },
          onClick: () => {
            if (state) {
              if (state.route === "Katbook (Published)") {
                return 0;
              } else {
                dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
              }
            } else {
              dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
            }
          },
          txt: state.route === "Katbook (Published)" ? state.route : null,
        },

        // {
        //   _tag: "CSidebarNavItem",
        //   name: "Hybrid Offline",
        //   to: "/KatbookHybrid",
        //   icon: "cil-book",
        //   //       style:{
        //   // display:State.userCreds.userType === 'Teaching'? 'none':'',
        //   //       },
        //   onClick: () => {
        //     if (state) {
        //       if (state.route === "Katbook Creation") {
        //         return 0;
        //       } else {
        //         dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //       }
        //     } else {
        //       dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //     }
        //   },
        //   txt: state.route === "Katbook Creation" ? state.route : null,
        // },

        // {
        //   _tag: "CSidebarNavItem",
        //   name: "Proceum Content",
        //   to: "/ProceumContent",
        //   icon: "cil-book",
        //   //       style:{
        //   // display:State.userCreds.userType === 'Teaching'? 'none':'',
        //   //       },
        //   onClick: () => {
        //     if (state) {
        //       if (state.route === "Proceum Content") {
        //         return 0;
        //       } else {
        //         dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //       }
        //     } else {
        //       dispatch({ type: "KBC_ROUTES", route: "", subRoute: "" });
        //     }
        //   },
        //   txt: state.route === "Proceum Content" ? state.route : null,
        // },
      ];
};

export default Navigation;
